// extracted by mini-css-extract-plugin
module.exports = {"banner":"MapBanner_banner__2AIJo"};